import React from 'react';
import './AIProjects.css';
import IconBadge from './IconBadge';
import SectionCTA from './SectionCTA';
import useSpotlight from '../hooks/useSpotlight';
import useScrollReveal from '../hooks/useScrollReveal';

const projects = [
  {
    title: 'AI E-Reputation Monitoring System',
    client: 'BrandBeat',
    description: 'AI-powered platform for monitoring brand reputation, sentiment analysis, weak signal detection, and crisis anticipation.',
    icon: 'monitoring',
  },
  {
    title: 'AI Customer Support Chatbot for Car Rental',
    client: 'RentShift',
    description: 'Intelligent chatbot for customer support, reservations, rental assistance, and WhatsApp integration.',
    icon: 'chatbot',
  },
  {
    title: 'Intelligent Document Search Assistant',
    client: 'Sejalny',
    description: 'Semantic AI search engine for fast access to enterprise documents and internal knowledge.',
    icon: 'search',
  },
  {
    title: 'AI Workflow Automation Platform',
    client: 'Varois Entreprise',
    description: 'Automation platform connecting business workflows, APIs, and AI-driven operations.',
    icon: 'workflow',
  },
  {
    title: 'AI POC Application Development',
    client: 'Varois Entreprise',
    description: 'Creation of AI proof-of-concept applications and workflow automations using N8N and AI integrations.',
    icon: 'poc',
  },
  {
    title: 'AI & Automation Consulting',
    client: 'ALAII',
    description: 'AI transformation consulting, automation strategy, and operational optimization.',
    icon: 'consulting',
  },
  {
    title: 'AI Audio Integration Bot',
    client: 'Lynx',
    description: 'AI voice/audio integration system for conversational and automated interactions.',
    icon: 'audio',
  },
  {
    title: 'AI Recognition System',
    client: 'OLO Mobile App',
    description: 'AI-based recognition and smart detection features integrated into mobile applications.',
    icon: 'recognition',
  },
];

export default function AIProjects() {
  const headerRef = useScrollReveal();
  useSpotlight('.project-card');
  return (
    <section className="ai-projects" id="projects">
      <div className="ai-projects-inner">
        <div className="ai-projects-header reveal" ref={headerRef}>
          <span className="section-label">AI Projects</span>
          <h2 className="section-title">Selected Projects Built Around Real Operations</h2>
          <p className="ai-projects-sub">
            These are project examples and case-study style references, not off-the-shelf products. They show how AI can be shaped around specific operational needs across monitoring, search, automation, support, and internal workflows.
          </p>
        </div>

        <div className="ai-projects-grid">
          {projects.map((project) => (
            <article className="project-card" key={`${project.client}-${project.title}`}>
              <div className="project-card-top">
                <IconBadge name={project.icon} size="lg" className="project-icon" />
                <div className="project-client-tag">{project.client}</div>
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-context">Custom implementation example</div>
            </article>
          ))}
        </div>
        <SectionCTA label="Want to explore what a similar system could look like for your business?" />
      </div>
    </section>
  );
}
